/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverDayOffDriverDto } from '../models/DriverDayOffDriverDto';
import type { DriverDayOffListedAdminDto } from '../models/DriverDayOffListedAdminDto';
import type { DriverDayOffSourceType } from '../models/DriverDayOffSourceType';
import type { DriverDayOffStatus } from '../models/DriverDayOffStatus';
import type { DriverDayOffType } from '../models/DriverDayOffType';
import type { GetDriverDayOffsDriverResponse } from '../models/GetDriverDayOffsDriverResponse';
import type { Pagination1OfDriverDayOffListedAdminDto } from '../models/Pagination1OfDriverDayOffListedAdminDto';
import type { PostApproveDriverDayOffAdminRequest } from '../models/PostApproveDriverDayOffAdminRequest';
import type { PostDriverDayOffAdminRequest } from '../models/PostDriverDayOffAdminRequest';
import type { PostDriverDayOffRequestDriver } from '../models/PostDriverDayOffRequestDriver';
import type { PostRejectDriverDayOffAdminRequest } from '../models/PostRejectDriverDayOffAdminRequest';
import type { PutDriverDayOffAttachmentImageRequestDriver } from '../models/PutDriverDayOffAttachmentImageRequestDriver';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverDayOffsService {
    /**
     * @returns DriverDayOffDriverDto OK
     * @throws ApiError
     */
    public static postDriverDayOffDriver({
        requestBody,
    }: {
        requestBody?: PostDriverDayOffRequestDriver,
    }): CancelablePromise<DriverDayOffDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/driverdayoffs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverDayOffsDriverResponse OK
     * @throws ApiError
     */
    public static getDriverDayOffsDriver({
        createdAtFrom,
        createdAtTo,
        startDateFrom,
        startDateTo,
        endDateFrom,
        endDateTo,
        statuses,
        page,
        limit,
    }: {
        createdAtFrom?: string,
        createdAtTo?: string,
        startDateFrom?: string,
        startDateTo?: string,
        endDateFrom?: string,
        endDateTo?: string,
        statuses?: Array<DriverDayOffStatus>,
        page?: number,
        limit?: number,
    }): CancelablePromise<GetDriverDayOffsDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverdayoffs',
            query: {
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'startDateFrom': startDateFrom,
                'startDateTo': startDateTo,
                'endDateFrom': endDateFrom,
                'endDateTo': endDateTo,
                'statuses': statuses,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverDayOffDriverDto OK
     * @throws ApiError
     */
    public static getCurrentActiveDriverDayOffDriver(): CancelablePromise<DriverDayOffDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverdayoffs/current/active',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postCancelDriverDayOffDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/driverdayoffs/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverDayOffDriverDto OK
     * @throws ApiError
     */
    public static postCompleteDriverDayOffDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverDayOffDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/driverdayoffs/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverDayOffDriverDto OK
     * @throws ApiError
     */
    public static putDriverDayOffAttachmentImageDriver({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutDriverDayOffAttachmentImageRequestDriver,
    }): CancelablePromise<DriverDayOffDriverDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/driver/v1/driverdayoffs/{id}/attachment-image',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverDayOffs`
     * @returns Pagination1OfDriverDayOffListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverDayOffsAdmin({
        driverId,
        regionId,
        status,
        source,
        type,
        startDateFrom,
        startDateTo,
        endDateFrom,
        endDateTo,
        requestedByUserId,
        approvedByUserId,
        page,
        limit,
    }: {
        driverId?: number,
        regionId?: number,
        status?: DriverDayOffStatus,
        source?: DriverDayOffSourceType,
        type?: DriverDayOffType,
        startDateFrom?: string,
        startDateTo?: string,
        endDateFrom?: string,
        endDateTo?: string,
        requestedByUserId?: string,
        approvedByUserId?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverDayOffListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverdayoffs',
            query: {
                'driverId': driverId,
                'regionId': regionId,
                'status': status,
                'source': source,
                'type': type,
                'startDateFrom': startDateFrom,
                'startDateTo': startDateTo,
                'endDateFrom': endDateFrom,
                'endDateTo': endDateTo,
                'requestedByUserId': requestedByUserId,
                'approvedByUserId': approvedByUserId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverDayOffs`
     * @returns DriverDayOffListedAdminDto OK
     * @throws ApiError
     */
    public static postDriverDayOffAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverDayOffAdminRequest,
    }): CancelablePromise<DriverDayOffListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdayoffs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverDayOffs`
     * @returns DriverDayOffListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverDayOffAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverDayOffListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverdayoffs/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverDayOffs`
     * @returns DriverDayOffListedAdminDto OK
     * @throws ApiError
     */
    public static postApproveDriverDayOffAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostApproveDriverDayOffAdminRequest,
    }): CancelablePromise<DriverDayOffListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdayoffs/{id}/approve',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverDayOffs`
     * @returns DriverDayOffListedAdminDto OK
     * @throws ApiError
     */
    public static postRejectDriverDayOffAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostRejectDriverDayOffAdminRequest,
    }): CancelablePromise<DriverDayOffListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdayoffs/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverDayOffs`
     * @returns DriverDayOffListedAdminDto OK
     * @throws ApiError
     */
    public static postCancelDriverDayOffAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverDayOffListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdayoffs/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverDayOffs`
     * @returns DriverDayOffListedAdminDto OK
     * @throws ApiError
     */
    public static postCompleteDriverDayOffAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverDayOffListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdayoffs/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
